import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children, allowIncompleteProfile = false }) => {
  const location = useLocation();

  // Token aus URL holen
  const params = new URLSearchParams(location.search);
  const tokenFromUrl = params.get("token");

  let token = localStorage.getItem("authToken");

  // Wenn Token in URL → übernehmen + dekodieren
  if (tokenFromUrl && tokenFromUrl !== token) {
    localStorage.setItem("authToken", tokenFromUrl);
    token = tokenFromUrl;

    try {
      const decoded = JSON.parse(atob(tokenFromUrl.split(".")[1]));
      if (decoded.profileIncomplete !== undefined) {
        localStorage.setItem("profileIncomplete", decoded.profileIncomplete);
      }
    } catch (err) {
      console.error("Fehler beim Dekodieren des Tokens:", err);
    }
  }

  const profileIncomplete = localStorage.getItem("profileIncomplete");

  // Kein Token → Login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Token aus URL → RegisterUser rendern
  if (tokenFromUrl) {
    return children;
  }

  // Warten bis profileIncomplete gesetzt wurde
  if (profileIncomplete === null) {
    return null;
  }

  const isIncomplete = profileIncomplete === "true";

  // Unvollständiges Profil → nur RegisterUser erlaubt
  if (isIncomplete && !allowIncompleteProfile) {
    return <Navigate to="/register-user" replace />;
  }

  // Vollständiges Profil → RegisterUser blockieren
  if (!isIncomplete && location.pathname === "/register-user") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;